<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="400" persistent>
      <v-card class="mx-auto text-center">
        <v-card-text class="primary white--text controlled-font pt-4">
          {{ title }}
        </v-card-text>
        <v-card-text
          v-show="!!message"
          class="primary--text controlled-font pa-4 mx-auto"
        >
          <span v-html="message"></span>
        </v-card-text>
        <v-card-actions class="pt-2 pr-5 pb-5 flex-wrap">
          <!-- <v-spacer class=""></v-spacer> -->
          <v-layout row wrap>
            <div class="col-sm-6">
              <v-btn
                class="primary controlled-font"
                text
                @click.native="agree"
                >{{ okText }}</v-btn
              >
            </div>
            <div class="col-sm-6">
              <v-btn
                class="secondary controlled-font"
                text
                @click.native="cancel"
                >{{ cancelText }}</v-btn
              >
            </div>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      message: "",
      okText: "OK",
      cancelText: "Cancel",
      dialog: false,
      resolve: null,
      reject: null,
    };
  },
  methods: {
    open(title, message, buttonText) {
      this.title = title;
      this.message = message;
      this.dialog = true;
      if (buttonText) {
        this.okText = buttonText.ok;
        this.cancelText = buttonText.cancel;
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.dialog = false;
      this.resolve(true);
    },
    cancel() {
      this.dialog = false;
      this.resolve(false);
    },
  },
};
</script>

<style scoped></style>
